import "./VerifiedExchangeConnection.css";
import {
  setBinanceConnecting,
  setLoading,
} from "../../../../redux/loading/loadingSlice";
import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import { updateUser } from "../../../../redux/users/usersSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import Copy from "../../../../assets/images/Copy.svg";
import dropdownAngle from "../../../../assets/images/dropdownAngle.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import TradeMarketSegment from "../../../sharedPages/CommonComponents/TradeMarketSegment/TradeMarketSegment";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import rightAnglePath from "../../../../assets/images/rightAnglePath.svg";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import {
  redirectToBinanceOAuth,
  redirectToBybitOAuth,
} from "../../../../helpers/exchangeOAuth";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import VerificationApiModal from "../../../sharedPages/NewCopyTrade/ExchangeConnection/VerificationApiModal";
import SubscriptionConfirmModal from "../../../sharedPages/copyTradeCm/SubscriptionConfirmModal";

const IP_ADDRESS =
  window.location.hostname.split(".")[0] === "my"
    ? "108.129.27.187"
    : "52.214.92.9";

const VerifiedExchangeConnection = ({ user }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    apiKey: "",
    secretKey: "",
    exchange: "",
  });

  const [formErrors, setFormErrors] = useState({
    apiKey: false,
    secretKey: false,
  });

  const [isApiKeySelected, setisApiKeySelected] = useState(false);
  const [tradeMarketType, setTradeMarketType] = useState("both");
  const [savedPermissionType, setSavedPermissionType] = useState("both");
  const [isCredentialsConnected, setCredentialsConnected] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select Exchange");
  const [showModal, setShowModal] = useState({ show: false, buttonClick: "" });
  const [showOtpPopUp, setShowOtpPopUp] = useState({ show: false });
  const [permissionSaveLoading, setPermissionSaveLoading] = useState(false);
  const [showPermissionConfirm, setShowPermissionConfirm] = useState(false);

  const api = useApi();
  const buttonRef = useRef(null);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  const setExchangeCredentials = async (exchange) => {
    const data = await getUserCredentials(exchange?.toLowerCase());

    if (data?.status) {
      setCredentials({
        apiKey: data?.apiKey,
        exchange: data?.exchange,
        secretKey: data?.secretKey,
      });
    } else {
      setCredentials({
        apiKey: "",
        exchange,
        secretKey: "",
      });
    }

    return data;
  };

  const handleSelect = (optionText) => {
    const exchange = optionText.split(" ")[0];

    setExchangeCredentials(exchange);
    setisApiKeySelected(optionText.includes("API Keys"));
    setIsDropdownOpen(false);
    setSelectedOption(optionText);
    setFormErrors({
      apiKey: false,
      secretKey: false,
    });
  };

  const toggleDropdown = () => setIsDropdownOpen((prevState) => !prevState);

  const oauthBinance = async () => {
    let userAgent = navigator?.userAgent;

    if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(true));
    }

    dispatch(setBinanceConnecting(true));
    redirectToBinanceOAuth({ permissionType: tradeMarketType, connectMode: true });
  };

  const oauthBybit = async () => {
    let userAgent = navigator?.userAgent;

    if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(true));
    }

    localStorage.setItem("binanceCondition", true);
    redirectToBybitOAuth({ permissionType: tradeMarketType, connectMode: true });
  };

  const getUserCredentials = async (exchangeKey) => {
    const response = await api(
      "get",
      `binanceCredentials/index/${exchangeKey}`
    );

    const { apiKey, exchange, secretKey } = response?.data || {};

    if (apiKey && exchange && secretKey) {
      return { apiKey, exchange, secretKey, status: true };
    }

    return { status: false };
  };

  const connectManually = async ({ apiKey, secretKey, exchange }) => {
    const response = await api("post", "binanceCredentials/create", {
      apiKey,
      exchange,
      secretKey,
      permissionType: tradeMarketType,
      verifyMyTrade: window.location.pathname.includes("verifiedTrading"),
      fromExchnageConnection:true
    });

    if (response?.status){
      // toastify("Exchange connected successfully.", "success");
    }else {
      if (
        response?.message ===
        "Please make sure you've set it up correctly on your exchange."
      ) {
        toastify("Please make sure you’re using the right keys.");
        return;
      } else {
        toastify(response?.message);
      }
    }

    return response;
  };

  const handleConnect = async () => {
    const isQuickConnect =
      selectedOption === "Binance Quick Connect" ||
      selectedOption === "ByBit Quick Connect";

    const exchangeType = selectedOption.split(" ")[0].toLowerCase();

    // Check for missing keys when not using quick connect
    if (!isQuickConnect) {
      const missingApiKey = !credentials?.apiKey;
      const missingSecretKey = !credentials?.secretKey;

      if (missingApiKey || missingSecretKey) {
        let errorMsg = "Missing required: ";

        if (missingApiKey && missingSecretKey) {
          errorMsg += "API key and Secret key.";
        } else if (missingApiKey) {
          errorMsg += "API key.";
        } else if (missingSecretKey) {
          errorMsg += "Secret key.";
        }

        toastify(errorMsg, "error");
        setFormErrors({
          apiKey: missingApiKey,
          secretKey: missingSecretKey,
        });
        return;
      }
    }
    setIsLoading(true);

    // If quick connect and keys are present, treat it like manual connect
    if (isQuickConnect && credentials?.apiKey && credentials?.secretKey) {
      await connectManually(credentials);
      await fetchUserData();
    }
    // Quick connect via OAuth
    else if (isQuickConnect) {
      exchangeType === "binance" ? oauthBinance() : oauthBybit();
      // showNotificationToast("Exchange connected successfully.")
    }
    // Manual connect fallback
    else {
      await connectManually(credentials);
      await fetchUserData();
    }
    setIsLoading(false);
  };

  const fetchUserData = async () => {
    const myResponse = await api("get", "users/index");
    if (myResponse) {
      dispatch(updateUser(myResponse?.data?.user));
    }
  };

  const parsePermissionType = (value) => {
    if (value == null || value === "") return null;
    const normalized = String(value).toLowerCase().trim();
    if (normalized === "future") return "futures";
    if (normalized === "spot" || normalized === "futures" || normalized === "both") {
      return normalized;
    }
    return null;
  };

  const showPermissionSaveButton =
    isCredentialsConnected && tradeMarketType !== savedPermissionType;

  const handlePermissionTypeChange = (nextType) => {
    setTradeMarketType(nextType);
  };

  const formatPermissionLabel = (type) =>
    type === "spot"
      ? "Spot"
      : type === "futures"
        ? "Futures"
        : "Both (Spot & Futures)";

  const getPermissionChangeAlert = (fromType, toType) => {
    const fromHasFutures = fromType === "futures" || fromType === "both";
    const fromHasSpot = fromType === "spot" || fromType === "both";
    const toHasFutures = toType === "futures" || toType === "both";
    const toHasSpot = toType === "spot" || toType === "both";

    const closingFutures = fromHasFutures && !toHasFutures;
    const closingSpot = fromHasSpot && !toHasSpot;

    if (closingFutures && closingSpot) {
      return "Your futures and spot live trades will be closed.";
    }
    if (closingFutures) {
      return "Your futures live trades will be closed.";
    }
    if (closingSpot) {
      return "Your spot live trades will be closed.";
    }
    return null;
  };

  const handleSavePermissionType = async () => {
    if (!isCredentialsConnected || !showPermissionSaveButton) return false;

    setPermissionSaveLoading(true);
    try {
      const isBinance = Boolean(user?.binanceCredentials?.isConnected);
      const exchange = isBinance ? "Binance" : "ByBit";
      const credentialKey = isBinance
        ? "binanceCredentials"
        : "bybitCredentials";

      const response = await api("post", "binanceCredentials/update", {
        permissionType: tradeMarketType,
        exchange,
      });

      if (response?.status) {
        setSavedPermissionType(tradeMarketType);
        setTradeMarketType(tradeMarketType);

        await api("post", "users/update", {
          [credentialKey]: {
            ...user?.[credentialKey],
            permissionType: tradeMarketType,
          },
        });

        const myResponse = await api("get", "users/index");
        if (myResponse?.data?.user) {
          const nextUser = { ...myResponse.data.user };
          if (nextUser?.[credentialKey]) {
            nextUser[credentialKey] = {
              ...nextUser[credentialKey],
              permissionType:
                parsePermissionType(nextUser[credentialKey]?.permissionType) ||
                tradeMarketType,
            };
          }
          dispatch(updateUser(nextUser));
        }

        const marketLabel = formatPermissionLabel(tradeMarketType);
        const title = response?.message || "Trade markets updated";
        const message = `Status: ${marketLabel}`;
        showNotificationToast(title, message);
        window.dispatchEvent(
          new CustomEvent("fcm-notification", {
            detail: {
              title,
              message,
              body: message,
              createdAt: new Date().toISOString(),
              time: new Date().toLocaleString(),
            },
          })
        );
        return true;
      } else {
        toastify(response?.message || "Failed to update trade markets", "error");
        return false;
      }
    } catch (error) {
      toastify(error?.message || "Failed to update trade markets", "error");
      return false;
    } finally {
      setPermissionSaveLoading(false);
    }
  };

  const callApi = async () => {
    if (showOtpPopUp?.buttonClick === "Disconnect") {
      let credentialToUpdate = {};
      if (user?.binanceCredentials?.isConnected) {
        credentialToUpdate = {
          binanceCredentials: {
            ...user?.binanceCredentials,
            isConnected: false,
            isConnectedSpot: false,
            isConnectedUsdFuture: false,
          },
        };
      }

      if (user?.bybitCredentials?.isConnected) {
        credentialToUpdate = {
          bybitCredentials: {
            ...user?.bybitCredentials,
            isConnected: false,
            isConnectedSpot: false,
            isConnectedDerivatives: false,
          },
        };
      }

      const response = await api("post", "users/update", credentialToUpdate);
      if (response?.status) {
        if (user?.role === "leader")
          api("post", "livetrade/closeAllMembersTrade");

        await fetchUserData();
        // showNotificationToast("Exchange disconnected!", "All subscriber trades have been closed and they've been notified.Reconnect to resume copy trading.");
        
      } else {
        toastify(response?.message);
      }
    } else if (showOtpPopUp?.buttonClick === "Delete") {
      const hasBinanceCredentials = Boolean(
        user?.binanceCredentials?.isConnected ||
          user?.binanceCredentials?.apiKey ||
          (user?.binanceCredentials &&
            Object.keys(user.binanceCredentials).length > 0)
      );
      const hasBybitCredentials = Boolean(
        user?.bybitCredentials?.isConnected ||
          user?.bybitCredentials?.apiKey ||
          (user?.bybitCredentials &&
            Object.keys(user.bybitCredentials).length > 0)
      );

      const credentialToUpdate = {
        ...(hasBinanceCredentials ? { binanceCredentials: {} } : {}),
        ...(hasBybitCredentials ? { bybitCredentials: {} } : {}),
        uniqueIds: {},
      };

      dispatch(
        updateUser({
          ...user,
          ...(hasBinanceCredentials ? { binanceCredentials: {} } : {}),
          ...(hasBybitCredentials ? { bybitCredentials: {} } : {}),
          uniqueIds: {},
        })
      );
      setCredentials({
        apiKey: "",
        secretKey: "",
        exchange: "",
      });
      setCredentialsConnected(false);
      setisApiKeySelected(false);
      setSelectedOption("Select Exchange");
      setTradeMarketType("both");
      setSavedPermissionType("both");

      const response = await api("post", "users/update", credentialToUpdate);
      if (response?.status === false) {
        toastify(response?.message || "Failed to delete API keys", "error");
      }
      await fetchUserData();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (
      user?.bybitCredentials?.isConnected ||
      user?.binanceCredentials?.isConnected
    ) {
      setCredentialsConnected(true);
      setisApiKeySelected(true);

      const rawPermission = user?.binanceCredentials?.isConnected
        ? user?.binanceCredentials?.permissionType
        : user?.bybitCredentials?.permissionType;
      const fromApi = parsePermissionType(rawPermission);

      if (fromApi) {
        setSavedPermissionType((prevSaved) => {
          setTradeMarketType((prevTrade) =>
            prevTrade !== prevSaved ? prevTrade : fromApi
          );
          return fromApi;
        });
      }

      if (user?.binanceCredentials?.isConnected) {
        setSelectedOption("Binance API Keys");
        setExchangeCredentials("binance");
      } else if (user?.bybitCredentials?.isConnected) {
        setSelectedOption("ByBit API Keys");
        setExchangeCredentials("bybit");
      }
    } else {
      setCredentialsConnected(false);
      setisApiKeySelected(false);
      setSelectedOption("Select Exchange");
      setTradeMarketType("both");
      setSavedPermissionType("both");
    }
  }, [user]);

  const handleApiKeyChange = (e) => {
    setFormErrors((prev) => ({
      ...prev,
      apiKey: false,
    }));

    setCredentials({
      ...credentials,
      apiKey: e.target.value,
    });
  };

  const handleSecretKeyChange = (e) => {
    setFormErrors((prev) => ({
      ...prev,
      secretKey: false,
    }));

    setCredentials({
      ...credentials,
      secretKey: e.target.value,
    });
  };

  return (
    <div className="exchangeBox" id="ExchangeConnection">
      <div className="grid-header-row align-items-center">
        <div className="grid-header-left">
          <div className="titleWrapper">
            <p className="title">Exchange Connection</p>
            <InfoPopup
              contentItems={[
                { text: "Connected Trading Account", type: "heading" },
                {
                  text: " This is the account used for trade and performance verification. To verify another account, disconnect and connect the desired exchange. <br/> <br/>",
                  type: "paragraph",
                },
                {
                  text: "If you want to switch exchange account",
                  type: "heading",
                },
                {
                  text: "Disconnect your connected exchange account and choose another exchange.Note: Don’t disconnect if verifying performance for a subscription, as it may affect calculations.<br/>",
                  type: "paragraph",
                },
              ]}
            />
          </div>
          <p className="subTitle">
            The connected trading account you're verifying
          </p>
        </div>
      </div>
      <div className="grid-row">
        <div className={`grid-col ${selectedOption === "Select Exchange" ? "grid-col--expanded" : ""}`}>
          <div className="customDropdown" ref={dropdownRef}>
            <button
              className={`dropdownButton fixedWidth1440 ${
                selectedOption !== "Select Exchange" || isDropdownOpen
                  ? "active"
                  : ""
              }`}
              disabled={isCredentialsConnected}
              onClick={toggleDropdown}
              ref={buttonRef}
            >
              <p>
                <span
                  className={`btnSpanOne ${
                    selectedOption === "Select Exchange" && "opacity40"
                  }`}
                >
                  {selectedOption === "Select Exchange"
                    ? selectedOption
                    : selectedOption.split(" ")[0]}
                </span>
                <span className="btnSpan">
                  {selectedOption === "Select Exchange"
                    ? ""
                    : selectedOption.split(" ").splice(1).join(" ")}
                </span>
              </p>
              <span
                className={`dropdownArrow ${isDropdownOpen && "rotate"}`}
                style={{ opacity: selectedOption !== "Select Exchange" && 1 }}
              >
                <img alt="" src={dropdownAngle} />
              </span>
            </button>
            {isDropdownOpen && (
              <div className="dropdownContent">
                <p onClick={() => handleSelect("Binance Quick Connect")}>
                  <span className="span1">Binance</span>
                  <span>Quick Connect</span>
                  <span className="arrowspan">
                    <img src={rightAnglePath} alt="arrow" />
                  </span>
                </p>
                <p onClick={() => handleSelect("Binance API Keys")}>
                  <span className="span1">Binance</span>
                  <span>API Keys</span>
                  <span className="arrowspan">
                    <img src={rightAnglePath} alt="arrow" />
                  </span>
                </p>
                <p onClick={() => handleSelect("ByBit Quick Connect")}>
                  <span className="span1">ByBit</span>
                  <span>Quick Connect</span>
                  <span className="arrowspan">
                    <img src={rightAnglePath} alt="arrow" />
                  </span>
                </p>
                <p onClick={() => handleSelect("ByBit API Keys")}>
                  <span className="span1">ByBit</span>
                  <span>API Keys</span>
                  <span className="arrowspan">
                    <img src={rightAnglePath} alt="arrow" />
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
        {isApiKeySelected && (
          <>
            <div className="grid-col">
              <div className="fixedWidth1440 mx-auto">
                <FloatingTextFiled
                  className={`${formErrors.apiKey && "invalid"}`}
                  disabled={isCredentialsConnected}
                  forLabel="apiKey"
                  id="apiKey"
                  label="API Key"
                  onChange={handleApiKeyChange}
                  placeholder="API Key"
                  type="text"
                  value={
                    isCredentialsConnected
                      ? "*************************"
                      : credentials.apiKey
                  }
                  focusedAllowed={false}
                />
              </div>
            </div>
            <div className="grid-col">
              <div className="fixedWidth1440 mx-auto">
                <FloatingTextFiled
                  className={`fixedWidth1440 ${
                    formErrors.secretKey && "invalid"
                  }`}
                  disabled={isCredentialsConnected}
                  forLabel="secretKey"
                  id="secretKey"
                  label="Secret Key"
                  onChange={handleSecretKeyChange}
                  placeholder="Secret Key"
                  type="text"
                  value={
                    isCredentialsConnected
                      ? "*************************"
                      : credentials.secretKey
                  }
                  focusedAllowed={false}
                />
              </div>
            </div>
          </>
        )}
        {!isCredentialsConnected && selectedOption !== "Select Exchange" && (
          <>
            {selectedOption === "Binance API Keys" && (
              <div className="grid-col">
                <div className="fixedWidth1440 ms-auto copyIpBox">
                  <FloatingTextFiled
                    className="ipFiled fixedWidth1440"
                    disabled={true}
                    forLabel="binanceIp"
                    id="binanceIp"
                    label="IP Address"
                    onChange={() => {}}
                    placeholder="IP"
                    value={IP_ADDRESS}
                    focusedAllowed={false}
                  />
                  <img
                    alt=""
                    className="copyIp"
                    onClick={() => {
                      navigator.clipboard.writeText(IP_ADDRESS).then(() => {
                        toastify("IP Address copied to clipboard!", "success");
                      });
                    }}
                    src={Copy}
                  />
                </div>
              </div>
            )}
            <div className="grid-col">
              <div
                className={`fixedWidth1440 ${
                  selectedOption.includes("Quick Connect") && "mx-auto"
                }
                ${
                  selectedOption === "Binance API Keys" ? "me-auto" : "ms-auto"
                }`}
              >
                <BubbleSvgButton
                  onClick={handleConnect}
                  text={"Connect"}
                  type="button"
                  variant="green"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                  disabled={isLoading}
                  isLoading={isLoading}
                />
              </div>
            </div>
          </>
        )}

        {isCredentialsConnected && (
          <>
            <div className="grid-col">
              <div
                className={`fixedWidth1440 ${
                  selectedOption.includes("Quick Connect")
                    ? "mx-auto"
                    : "ms-auto"
                }`}
              >
                <BubbleSvgButton
                  onClick={() => {
                    setShowModal({ buttonClick: "Disconnect", show: true });
                  }}
                  text={"Disconnect"}
                  type="button"
                  variant="red"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className="grid-col">
              <div
                className={`fixedWidth1440  ${
                  selectedOption.includes("Quick Connect")
                    ? "mx-auto"
                    : "me-auto"
                }`}
              >
                <BubbleSvgButton
                  onClick={() => {
                    setShowModal({ buttonClick: "Delete", show: true });
                  }}
                  text={"Delete API"}
                  type="button"
                  variant="black"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                  disabled={isLoading}
                />
              </div>
            </div>
          </>
        )}
      </div>

      <div className="grid-row mt-d">
        {!isCredentialsConnected &&
          (isApiKeySelected || selectedOption.includes("Quick Connect")) && (
          <div className="grid-col exchangePermissionCol">
            <div className="">
              <TradeMarketSegment
                className="TradeMarketSegment--page"
                value={tradeMarketType}
                onChange={handlePermissionTypeChange}
                hint="Choose which markets you’ll use with this connection."
              />
            </div>
          </div>
        )}
        {isCredentialsConnected && (
          <>
            <div className="grid-col exchangePermissionCol">
              <div className="">
                <TradeMarketSegment
                  className="TradeMarketSegment--page"
                  value={tradeMarketType}
                  onChange={handlePermissionTypeChange}
                  hint="Choose which markets you’ll use with this connection."
                />
              </div>
            </div>
            {showPermissionSaveButton && (
              <div className="grid-col exchangePermissionSaveCol">
                <div className="fixedWidth1440">
                  <BubbleSvgButton
                    onClick={() => setShowPermissionConfirm(true)}
                    disabled={permissionSaveLoading}
                    isLoading={permissionSaveLoading}
                    text={"Save"}
                    type="button"
                    variant="green"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <SubscriptionConfirmModal
        show={showPermissionConfirm}
        onClose={() => setShowPermissionConfirm(false)}
        title="Change trade markets?"
        subtext={`You're about to switch from ${formatPermissionLabel(
          savedPermissionType
        )} to ${formatPermissionLabel(tradeMarketType)}.`}
        alert={getPermissionChangeAlert(
          savedPermissionType,
          tradeMarketType
        )}
        confirmText="Yes"
        cancelText="No"
        isLoading={permissionSaveLoading}
        onConfirm={async () => {
          const ok = await handleSavePermissionType();
          if (ok) setShowPermissionConfirm(false);
        }}
        onCancel={() => setShowPermissionConfirm(false)}
      />

      <VerificationApiModal
        showDisConnectPopup={showModal}
        onClose={() => {
          setShowModal({ show: false, buttonClick: "" });
          setShowOtpPopUp({
            show: false,
            buttonClick: "",
          });
        }}
        disConnectYesAction={() => {
          setShowOtpPopUp({
            show: true,
            buttonClick: showModal?.buttonClick,
          });
          setShowModal({ buttonClick: "", show: false });
        }}
        showEmailPopUp={showOtpPopUp}
        setShowEmailPopUp={setShowOtpPopUp}
        callApi={callApi}
      />
    </div>
  );
};

export default VerifiedExchangeConnection;
